import { registerEvents } from "./skyward.ui.events";
import { loadContent } from "./skyward.ui.window";
import { JQueryInput } from "./types";

const classes = {
    referenceView: "referenceview",
    referenceSlats: "reference-slats",
    slatDataImage: "slatDataImage",
    slatDataIcon: "slatDataIcon",
    dynamic: "dynamic",
}

export function reloadReferenceByControlId (controlId: string)
{
    // We use the controlId to see which part of the screen we are refreshing: moduleContent or detailsPanel. There could potentially be 
    // 2 reference views on the screen and we only want to refresh the one that is potentially affected and needs to be reloaded.
    // Whichever area the controlId is in is the area where we want to refresh the reference view.

    let referenceView: JQuery<HTMLElement>;
    const moduleContent = $("#moduleContent");
    const detailsPanel = $("#detailsPanel");
    let renderedInDetailsPanel = false;

    if (detailsPanel.length > 0)
    {
        if (detailsPanel.find("#" + controlId).length > 0)
        {
            referenceView = detailsPanel.find(classes.referenceView.dot());
            renderedInDetailsPanel = true;
        }
        else
        {
            referenceView = moduleContent.find(classes.referenceView.dot());
        }
    }
    else
    {
        referenceView = moduleContent.find(classes.referenceView.dot());
    }

    reloadReference(referenceView, renderedInDetailsPanel);
};

export function reloadReferenceByButton (button: JQuery<HTMLButtonElement>)
{
    const referenceView = button.parents(classes.referenceView.dot());
    let renderedInDetailsPanel = false;
    const detailsPanel = $("#detailsPanel");
    if (detailsPanel.find(referenceView).length > 0)
    {
        renderedInDetailsPanel = true;
    }

    reloadReference(referenceView, renderedInDetailsPanel);
};

function openRefDetails(data: { [key: string]: any })
{
    if (!data.area || !data.controller || !data.action || !data.primarykeyvalue)
    {
        return;
    }
    loadContent("popout", data.area, data.controller, data.action, data.primarykeyvalue, { tab: data.tab });
}

function reloadReference(referenceView: JQuery<HTMLElement>, renderedInDetailsPanel: boolean)
{
    if (referenceView.length == 0)
    {
        return;
    }

    const id = referenceView.attr("id");
    const refData = referenceView.data();

    if (id == null || refData == null)
    {
        return;
    }

    loadContent(id, refData.module, refData.object, "UpdateReferenceArea", refData.dataObjectPrimaryKey, { screen: refData.screen, task: refData.task, renderInDetailsPanel: renderedInDetailsPanel, securityhash: refData.securityhash, name: refData.name });
}

registerEvents("reference",
    {
        openDetails: function (this: JQueryInput)
        {
            openRefDetails($(this).data());
        }
    }
);